<template>
  <v-dialog
    v-model="visible"
    :close-on-content-click="false"
    transition="scale-transition"
    max-width="800px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="info"
        icon
        title="Configure Stop Permissions"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">
        Configure Stop Permissions - {{ route.name }}
      </v-card-title>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Order</th>
                <th class="text-left">Location</th>
                <th class="text-left">Allow Embark</th>
                <th class="text-left">Allow Disembark</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stop in sortedStops" :key="stop.id">
                <td>{{ stop.order }}</td>
                <td>{{ stop.location.name }}</td>
                <td>
                  <v-switch
                    v-model="stop.allowEmbark"
                    @change="updateStopSettings(stop)"
                    :loading="updatingStopId === stop.id"
                    :disabled="!stop.allowDisembark"
                    dense
                    hide-details
                  ></v-switch>
                </td>
                <td>
                  <v-switch
                    v-model="stop.allowDisembark"
                    @change="updateStopSettings(stop)"
                    :loading="updatingStopId === stop.id"
                    :disabled="!stop.allowEmbark"
                    dense
                    hide-details
                  ></v-switch>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="visible = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "StopSettings",
  props: {
    route: Object,
    getRoutes: Function,
    message: Function,
    errorMessage: Function,
  },
  data: () => ({
    visible: false,
    updatingStopId: null,
  }),
  computed: {
    sortedStops() {
      return [...this.route.stops].sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    async updateStopSettings(stop) {
      // Validate that at least one option is enabled
      if (!stop.allowEmbark && !stop.allowDisembark) {
        // Revert the change
        if (stop.allowEmbark === false) {
          stop.allowEmbark = true;
        } else {
          stop.allowDisembark = true;
        }
        this.errorMessage(
          "Each route stop must allow either embark or disembark (or both)"
        );
        return;
      }

      this.updatingStopId = stop.id;
      try {
        const response = await axios({
          url: `${
            process.env.VUE_APP_BASE_URL ?? ""
          }/api/updateroutestopsettings`,
          method: "POST",
          headers: { Authorization: localStorage.getItem("Authorization") },
          data: JSON.stringify({
            id: stop.id,
            allowEmbark: stop.allowEmbark,
            allowDisembark: stop.allowDisembark,
          }),
        });
        this.message(response.data.message);
        this.getRoutes();
      } catch (error) {
        if (error.response) {
          this.errorMessage(error.response.data.error);
        }
        // Revert the change on error
        this.getRoutes();
      } finally {
        this.updatingStopId = null;
      }
    },
  },
};
</script>
